import { FC } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';
import { FUND_VALUE_PROGRESSION_LEGEND_ITEMS } from '../../../FundValueProgression';

const styles = StyleSheet.create({
  legend: {
    gap: 6,
    paddingTop: 8,
  },
  legendItem: {
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderWidth: 0.75,
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    borderRadius: 100,
  },
  colorIndicator: {
    width: 4,
    height: 4,
    borderRadius: 1,
  },
  label: {
    fontFamily: 'MaisonNeue',
    fontSize: '6px',
    lineHeight: '8px',
    color: theme.palette.grey[900],
    fontWeight: 500,
  },
});

const FundValueProgressionChartLegend: FC = () => {
  return (
    <Row fullWidth justify="center" style={styles.legend}>
      {FUND_VALUE_PROGRESSION_LEGEND_ITEMS.map((item) => (
        <Row key={item.label} centered spacing="xxs" style={styles.legendItem}>
          <View
            style={[styles.colorIndicator, { backgroundColor: item.color }]}
          />
          <Text style={styles.label}>{item.label}</Text>
        </Row>
      ))}
    </Row>
  );
};

export default FundValueProgressionChartLegend;
